import { Link } from "react-router-dom";
import HeatMeter from "@/components/base/HeatMeter";
import { events } from "@/mocks/events";
import { formatHeat } from "@/utils/timeline";

export default function HotRanking() {
  const ranked = [...events].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const max = ranked[0]?.heat ?? 1;

  return (
    <section className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-shell mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-accent-700 uppercase">
            <span className="w-6 h-px bg-accent-500" />
            Weekly Ranking
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            本周爆料热度榜
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            热度综合讨论量、时间线更新频次与阅读停留时长计算，只反映关注程度，不代表我们对事件真实性的判断。
          </p>
          <div className="mt-6 p-4 rounded-lg bg-background-50 border border-background-200">
            <p className="text-xs text-foreground-500 leading-relaxed">
              榜单每 6 小时更新一次。若你发现某个事件的热度与实际讨论量明显不符，欢迎通过线索投递告诉我们。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 flex flex-col">
          {ranked.map((event, index) => (
            <Link
              key={event.id}
              to={`/events/${event.id}`}
              className="group flex items-center gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer"
            >
              <span
                className={`w-9 h-9 rounded-md flex items-center justify-center font-heading font-black shrink-0 ${
                  index < 3
                    ? "bg-accent-500 text-foreground-950"
                    : "bg-background-200 text-foreground-500"
                }`}
              >
                {index + 1}
              </span>
              <span className="flex-1 min-w-0">
                <span className="flex items-center gap-2 text-[11px] text-primary-700">
                  {event.category}
                  <span className="text-foreground-400">{event.updateTime}</span>
                </span>
                <span className="block mt-1 text-sm md:text-base font-medium leading-snug text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {event.title}
                </span>
                <span className="mt-2 flex items-center gap-3">
                  <HeatMeter heat={event.heat} max={max} comments={event.comments} />
                </span>
              </span>
              <span className="hidden sm:flex flex-col items-end shrink-0">
                <span className="font-heading text-lg font-bold text-foreground-950">
                  {formatHeat(event.heat)}
                </span>
                <span className="text-[11px] text-foreground-400">热度值</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}